module.exports = __webpack_public_path__ + "static/media/minus-circle-solid.a55b1015.svg";